__turbopack_context__.v({
  "actions": "RmDcZG_actions",
  "banner": "RmDcZG_banner",
  "buttonPrimary": "RmDcZG_buttonPrimary",
  "buttonSecondary": "RmDcZG_buttonSecondary",
  "content": "RmDcZG_content",
  "link": "RmDcZG_link",
  "settingsLink": "RmDcZG_settingsLink",
  "slideUp": "RmDcZG_slideUp",
  "text": "RmDcZG_text",
});
